import { Radio } from "@blueprintjs/core";
import { FieldGroup, useFGContext } from "nsitools-react";
import * as React from "react";

import { FGSRSHCheckboxInput } from "../../../components";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

export interface IFusionCheckboxProps {
  elementName: string;
  elementNameBis: string;
  fusedElementName: string;
  label: ETLCodes;
  elementValue: any;
  elementValueBis: any;
  selectLeft?: boolean;
}

export const FusionCheckbox: React.FunctionComponent<IFusionCheckboxProps> = ({
  elementName,
  elementNameBis,
  fusedElementName,
  label,
  elementValue,
  elementValueBis,
  selectLeft = null,
}) => {
  const [fusionRadioValue, setFusionRadioValue] = React.useState(selectLeft !== null ? (selectLeft ? "1" : "2") : "1");
  const [oldFusionValue, setOldFusionValue] = React.useState(fusionRadioValue);
  const { formik } = useFGContext();
  const { t } = useTl();

  React.useEffect(() => {
    setFusionRadioValue(selectLeft !== null ? (selectLeft ? "1" : "2") : "1");
  }, [selectLeft]);

  React.useEffect(() => {
    console.log("FusionRadioValue:", fusionRadioValue);
    console.log("OLD FusionRadioValue:", oldFusionValue);
    if (oldFusionValue !== fusionRadioValue) {
      if (fusionRadioValue === "1") {
        formik.setFieldValue(fusedElementName, elementValue);
      } else {
        formik.setFieldValue(fusedElementName, elementValueBis);
      }
      setOldFusionValue(fusionRadioValue);
    }
  }, [elementValue, elementValueBis, formik, fusedElementName, fusionRadioValue, oldFusionValue]);

  return (
    <>
      <div style={{ display: "flex" }}>
        <FieldGroup>
          <FieldGroup columns={[11, 1]}>
            <FGSRSHCheckboxInput name={elementName} label={t(label)} readonly />
            <Radio
  style={{ margin: "0.4rem 0rem", paddingLeft: "0rem", marginLeft: "1rem" }}
  value="1"
  checked={fusionRadioValue === "1"}
  onChange={(c) => {
    setFusionRadioValue(c.currentTarget.value);
    formik.setFieldValue(fusedElementName, elementValue);
  }}
  />
          </FieldGroup>
        </FieldGroup>
        {/*==================================================================================================*/}
        <FieldGroup>
          <div style={{ marginLeft: "13rem" }}>
            <FieldGroup columns={[11, 1]}>
              <FGSRSHCheckboxInput name={elementNameBis} label={t(label)} readonly />
              <Radio
  style={{ margin: "0.4rem 0rem", paddingLeft: "0rem", marginLeft: "1.2rem" }}
  value="2"
  checked={fusionRadioValue === "2"}
  onChange={(c) => {
    setFusionRadioValue(c.currentTarget.value);
    formik.setFieldValue(fusedElementName, elementValueBis);
  }}
  />
            </FieldGroup>
          </div>
        </FieldGroup>
      </div>
    </>
  );
};
